import { Container, Typography } from "@material-ui/core";
import { ifElse, prop } from "ramda";
import { memo } from "react";
import { SubmitHandler } from "react-hook-form";

import { Page } from "../../../router/enums";
import { Button } from "../../Button";
import { Grid } from "../../Grid";

import styles from "./Footer.module.scss";

type FooterContainerProps = {
  readonly isVisible: boolean;
  readonly isPrevRouteAvailable: boolean;
  readonly onSubmitNextRoute: SubmitHandler<any>;
  readonly onSubmitPrevRoute: SubmitHandler<any>;
  readonly currentRoute: Page;
};

function shouldAvoidRerender(
  prevProps: FooterContainerProps,
  nextProps: FooterContainerProps
) {
  return (
    prevProps.currentRoute === nextProps.currentRoute &&
    prevProps.isPrevRouteAvailable === nextProps.isPrevRouteAvailable &&
    prevProps.isVisible === nextProps.isVisible
  );
}

export const FooterContainer = memo<FooterContainerProps>(
  ({ onSubmitNextRoute, onSubmitPrevRoute, isPrevRouteAvailable }) => (
    <footer className={styles.footer}>
      <Container>
        <Grid
          container
          alignItems="center"
          className={styles.container}
          justify="flex-end"
        >
          <div className={styles.footerButtons}>
            {isPrevRouteAvailable && onSubmitPrevRoute && (
              <Button
                color="secondary"
                variant="outlined"
                spacingRight={5}
                onClick={onSubmitPrevRoute}
              >
                Wróć
              </Button>
            )}
            {onSubmitNextRoute && (
              <Button
                color="primary"
                variant="contained"
                onClick={onSubmitNextRoute}
              >
                Dalej
              </Button>
            )}
          </div>
          <div className={styles.footerText}>
            <Typography paragraph>
              Fleet Accident Management Services Sp.z o.o. działa w imieniu i na
              rzecz Euro Insurances DAC.
            </Typography>
          </div>
        </Grid>
      </Container>
    </footer>
  ),
  shouldAvoidRerender
);

export const Footer = ifElse(
  prop("isVisible"),
  (props) => <FooterContainer {...props} />,
  () => null
);
